module.exports = {
          srcSet: __webpack_public_path__ + "331e0f0660bcf9df489680230ad079e3-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "331e0f0660bcf9df489680230ad079e3-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "331e0f0660bcf9df489680230ad079e3-120.png",
          toString:function(){return __webpack_public_path__ + "331e0f0660bcf9df489680230ad079e3-120.png"},
          
          width: 120,
          height: 120
        }